"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var collapse_1 = require("./collapse");
var chevron_circle_right_1 = require("adp-react-icons/lib/fa/chevron-circle-right");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var Panel = /** @class */ (function (_super) {
    __extends(Panel, _super);
    function Panel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            expanded: _this.props.defaultExpanded || false
        };
        _this.handleSelect = function (event) {
            event.persist();
            event['selected'] = true;
            var _a = _this.props, onSelect = _a.onSelect, eventKey = _a.eventKey;
            if (onSelect) {
                onSelect(eventKey, event);
            }
            else {
                event.preventDefault();
            }
            if (event['selected']) {
                _this.handleToggle();
            }
        };
        _this.handleToggle = function () {
            _this.setState({
                expanded: !_this.state.expanded
            });
        };
        _this.isExpanded = function () {
            var expanded = _this.props.expanded;
            return expanded != null ? expanded : _this.state.expanded;
        };
        _this.renderCollapsibleBody = function (panelRole) {
            var collapseProps = {
                onEnter: _this.props.onEnter,
                onEntering: _this.props.onEntering,
                onEntered: _this.props.onEntered,
                onExit: _this.props.onExit,
                onExiting: _this.props.onExiting,
                onExited: _this.props.onExited,
                in: _this.isExpanded(),
                className: vdl_prefix_1.vdlPrefix('accordion-collapse'),
                enteringClassName: vdl_prefix_1.vdlPrefix('accordion-collapse--entering'),
                enteredClassName: vdl_prefix_1.vdlPrefix('accordion-collapse--entered'),
                exitingClassName: vdl_prefix_1.vdlPrefix('accordion-collapse--exiting'),
                exitedClassName: vdl_prefix_1.vdlPrefix('accordion-collapse--exited')
            };
            var props = {
                id: _this.props.id,
                ref: 'panel',
                'aria-hidden': !_this.isExpanded(),
                role: panelRole ? panelRole : undefined
            };
            return (React.createElement(collapse_1.Collapse, __assign({}, collapseProps),
                React.createElement("div", __assign({}, props), _this.renderBody())));
        };
        _this.renderBody = function () {
            var allChildren = _this.props.children;
            var bodyElements = [];
            var panelBodyChildren = [];
            var bodyClass = vdl_prefix_1.vdlPrefix('accordion-panel__body');
            function getProps() {
                return {
                    key: bodyElements.length
                };
            }
            function addPanelChild(child) {
                bodyElements.push(React.cloneElement(child, getProps()));
            }
            function addPanelBody(children) {
                bodyElements.push(React.createElement("div", __assign({ className: bodyClass }, getProps()), children));
            }
            function maybeRenderPanelBody() {
                if (panelBodyChildren.length === 0) {
                    return;
                }
                addPanelBody(panelBodyChildren);
                panelBodyChildren = [];
            }
            // Handle edge cases where we should not iterate through children.
            if (!Array.isArray(allChildren) || allChildren.length === 0) {
                if (_this.shouldRenderFill(allChildren)) {
                    addPanelChild(allChildren);
                }
                else {
                    addPanelBody(allChildren);
                }
            }
            else {
                allChildren.forEach(function (child) {
                    if (_this.shouldRenderFill(child)) {
                        maybeRenderPanelBody();
                        // Separately add the filled element.
                        addPanelChild(child);
                    }
                    else {
                        panelBodyChildren.push(child);
                    }
                });
                maybeRenderPanelBody();
            }
            return bodyElements;
        };
        _this.renderHeading = function (headerRole) {
            var header = _this.props.header;
            if (!header) {
                return null;
            }
            if (!React.isValidElement(header) || Array.isArray(header)) {
                header = _this.props.collapsible
                    ? _this.renderCollapsibleTitle(header, headerRole)
                    : header;
            }
            else {
                var className = classnames_1.classNames(vdl_prefix_1.vdlPrefix('accordion-panel__title'), header.props['className']);
                if (_this.props.collapsible) {
                    header = React.cloneElement(header, {
                        className: className,
                        children: _this.renderAnchor(header.props['children'], headerRole)
                    });
                }
                else {
                    header = React.cloneElement(header, { className: className });
                }
            }
            return (React.createElement("div", { className: vdl_prefix_1.vdlPrefix('accordion-panel__heading') }, header));
        };
        _this.renderAnchor = function (header, headerRole) {
            return (React.createElement("a", { href: '#' + (_this.props.id || ''), "aria-controls": _this.props.collapsible ? _this.props.id : null, "aria-expanded": _this.isExpanded(), "aria-selected": _this.isExpanded(), onClick: _this.handleSelect, role: headerRole },
                _this.props.icon,
                header));
        };
        _this.renderCollapsibleTitle = function (header, headerRole) {
            return (React.createElement("div", { className: vdl_prefix_1.vdlPrefix('accordion-panel__title'), role: "presentation" }, _this.renderAnchor(header, headerRole)));
        };
        _this.renderFooter = function () {
            if (!_this.props.footer) {
                return null;
            }
            return (React.createElement("div", { className: vdl_prefix_1.vdlPrefix('accordion-panel__footer') }, _this.props.footer));
        };
        return _this;
    }
    Panel.prototype.shouldRenderFill = function (child) {
        return React.isValidElement(child) && child.props['fill'] != null;
    };
    Panel.prototype.render = function () {
        var _a = this.props, headerRole = _a.headerRole, panelRole = _a.panelRole;
        var customProps = _1.omit(this.props, Object.keys(Panel.propTypes));
        var panelClasses = (_b = {},
            _b[vdl_prefix_1.vdlPrefix('accordion-panel')] = true,
            _b[vdl_prefix_1.vdlPrefix('accordion-panel--expanded')] = this.isExpanded(),
            _b[vdl_prefix_1.vdlPrefix('accordion-panel--collapsed')] = !this.isExpanded(),
            _b);
        return (React.createElement("div", __assign({}, customProps, { className: classnames_1.classNames(this.props.className, panelClasses), id: this.props.collapsible ? undefined : this.props.id }),
            this.renderHeading(headerRole),
            this.props.collapsible ? this.renderCollapsibleBody(panelRole) : this.renderBody(),
            this.renderFooter()));
        var _b;
    };
    Panel.propTypes = {
        collapsible: PropTypes.bool,
        onSelect: PropTypes.func,
        header: PropTypes.node,
        id: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        footer: PropTypes.node,
        defaultExpanded: PropTypes.bool,
        expanded: PropTypes.bool,
        eventKey: PropTypes.any,
        headerRole: PropTypes.string,
        panelRole: PropTypes.string,
        onEnter: collapse_1.Collapse.propTypes.onEnter,
        onEntering: collapse_1.Collapse.propTypes.onEntering,
        onEntered: collapse_1.Collapse.propTypes.onEntered,
        onExit: collapse_1.Collapse.propTypes.onExit,
        onExiting: collapse_1.Collapse.propTypes.onExiting,
        onExited: collapse_1.Collapse.propTypes.onExited,
        className: PropTypes.string,
        children: PropTypes.node,
        icon: PropTypes.node
    };
    Panel.defaultProps = {
        defaultExpanded: false,
        icon: React.createElement(chevron_circle_right_1.default, { className: vdl_prefix_1.vdlPrefix('accordion-panel__icon') })
    };
    return Panel;
}(React.Component));
exports.Panel = Panel;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/accordion/panel.js
// module id = 463
// module chunks = 0 1 2 3 4 5 6